// Stores the requested URL before redirecting to /signin, to return to it after
// login. Uses sessionStorage (not router state) because the 2FA flow triggers a
// full page reload.
const STORAGE_KEY = 'redirectAfterLogin';

// Auth routes: storing them would create a redirect loop.
const EXCLUDED_PREFIXES = [
  '/signin',
  '/logout',
  '/login',
  '/2fa-verify',
  '/password-reset',
  '/password-reset-request',
];

export const saveRedirectAfterLogin = (location) => {
  if (EXCLUDED_PREFIXES.some((prefix) => location.pathname.startsWith(prefix))) {
    return;
  }
  const target = `${location.pathname}${location.search}${location.hash}`;
  try {
    sessionStorage.setItem(STORAGE_KEY, target);
  } catch {
    // sessionStorage unavailable (private mode, quota): ignore.
  }
};

// Returns the stored target (and consumes it), or `fallback` if there is none.
export const consumeRedirectAfterLogin = (fallback = '/') => {
  try {
    const target = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    // Only accept an internal path, never an absolute URL (open redirect).
    if (target && target.startsWith('/') && !target.startsWith('//')) {
      return target;
    }
  } catch {
    // sessionStorage unavailable: fall back.
  }
  return fallback;
};
